// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Ml4_t","input":"styles_input__VeYdI","forgotPasswordText":"styles_forgotPasswordText__vYDB6"};